import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../helpers/custom-prop-types';
const list = [1, 2, 3, 4, 5];
const isDoneLevel = (level, userLevel) => {
    switch (true) {
        case level === 1 && userLevel === 1:
        case level === 2 && userLevel === 3:
        case level === 4 && userLevel === 6:
        case level === 5 && userLevel === 8:
            return 'width-50';
        case level === 1 && userLevel >= 2:
        case level === 2 && userLevel >= 4:
        case level === 3 && userLevel >= 5:
        case level === 4 && userLevel >= 7:
        case level === 5 && userLevel >= 9:
            return 'width-100';
        default:
            return 'width-0';
    }
};
const SkillList = (props) => {
    const { baseSkills } = props;
    return (_jsx("div", Object.assign({ className: 'skill-list' }, { children: baseSkills.map((baseSkill) => (_jsxs("div", Object.assign({ className: `skill-item ${baseSkill.level === 9 ? 'full' : ''}` }, { children: [_jsx("p", { children: baseSkill.name }), _jsx("div", Object.assign({ className: 'circleBox' }, { children: list.map((level) => (_jsxs("div", Object.assign({ className: 'circle-wrapper-box' }, { children: [_jsx("div", Object.assign({ className: `circle-wrapper ${isDoneLevel(level, baseSkill.level)}` }, { children: _jsx("div", { className: 'circle' }) })), _jsx("div", { className: 'circle is-bg' })] }), level))) }))] }), baseSkill.id))) })));
};
SkillList.propTypes = {
    baseSkills: propArrayShape().isRequired,
};
export default SkillList;
